import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_CITY_MUNICIPALITY } from "config/connString";
import useAxios from "utils/useAxios";

const getAllCityMunicipalities = createAsyncThunk(
  "citymunicipalities/get-all-citymunicipalities",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          search: data.search,
          pageSize: data.pageSize,
          pageNumber: data.pageNumber,
          sortField: data.sortField,
          sortDirection: data.sortDirection,
        },
      };
      const response = await api.get(URL_CITY_MUNICIPALITY, config);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { getAllCityMunicipalities };
